import script from "./MGMInfoPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGMInfoPanel.vue?vue&type=script&setup=true&lang=ts"

import "./MGMInfoPanel.vue?vue&type=style&index=0&id=13552f5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13552f5f"]])

export default __exports__